import React, { useState } from 'react';
import './DebugOverlay.css';

interface DebugOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  features: {
    browserPreview: boolean;
    showSessionIds: boolean;
  };
  onToggleFeature: (feature: string) => void;
}

const DebugOverlay: React.FC<DebugOverlayProps> = ({ isOpen, onClose, features, onToggleFeature }) => {
  if (!isOpen) return null;

  return (
    <div className="debug-overlay">
      <div className="debug-overlay-backdrop" onClick={onClose}></div>
      <div className="debug-overlay-panel">
        <div className="debug-overlay-header">
          <h2>Debug Panel</h2>
          <button className="debug-close-btn" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div className="debug-overlay-content">
          <div className="debug-section">
            <h3>Feature Toggles</h3>
            <div className="debug-feature-list">
              <div className="debug-feature-item">
                <label className="debug-toggle">
                  <input
                    type="checkbox"
                    checked={features.browserPreview}
                    onChange={() => onToggleFeature('browserPreview')}
                  />
                  <span className="debug-toggle-slider"></span>
                </label>
                <div className="debug-feature-info">
                  <span className="debug-feature-name">Browser Preview</span>
                  <span className="debug-feature-desc">Show embedded browser in chat</span>
                </div>
              </div>
              
              <div className="debug-feature-item">
                <label className="debug-toggle">
                  <input
                    type="checkbox"
                    checked={features.showSessionIds}
                    onChange={() => onToggleFeature('showSessionIds')}
                  />
                  <span className="debug-toggle-slider"></span>
                </label>
                <div className="debug-feature-info">
                  <span className="debug-feature-name">Show Session IDs</span>
                  <span className="debug-feature-desc">Display session tracking IDs on page</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DebugOverlay;
